import {translate} from "react-i18nify";

import * as actionTypes from "../constants/actionTypes";
import * as componentTypes from "../constants/componentTypes";
import * as handlers from "../constants/handlers";
import * as methods from "../constants/methods";

export const searchPanelInit = (tabId, type, local) => ({
    type: actionTypes.SEARCH_PANEL_INIT,
    payload: {
        tabId: tabId,
        type: type,
        local: local
    }
});

export const filterProductListByName = (tabId, productName) => ({
    type: actionTypes.FILTER_PRODUCT_LIST_BY_NAME,
    payload: {
        tabId: tabId,
        productName: productName
    }
});

export const filterFandeckListByName = (tabId, fandeckName, fandeckLimit, fandeckOffset) => ({
    type: actionTypes.FILTER_FANDECK_LIST_BY_NAME,
    payload: {
        tabId: tabId,
        fandeckName: fandeckName,
        fandeckLimit: fandeckLimit,
        fandeckOffset: fandeckOffset
    }
});

export const setActiveSelect = (tabId, activeSelect) => ({
    type: actionTypes.SEARCH_PANEL_SET_ACTIVE_SELECT,
    payload: {
        tabId: tabId,
        activeSelect: activeSelect
    }
});

export const setProductNameInput = (tabId, productName) => ({
    type: actionTypes.SEARCH_PANEL_SET_PRODUCT_NAME_INPUT,
    payload: {
        tabId: tabId,
        productName: productName
    }
});

export const setFandeckNameInput = (tabId, fandeckName) => ({
    type: actionTypes.SEARCH_PANEL_SET_FANDECK_NAME_INPUT,
    payload: {
        tabId: tabId,
        fandeckName: fandeckName
    }
});

export const setFormulaInput = (tabId, formula) => ({
    type: actionTypes.SEARCH_PANEL_SET_FORMULA_INPUT,
    payload: {
        tabId: tabId,
        formula: formula
    }
});

export const setFormulaNameInput = (tabId, formulaName) => ({
    type: actionTypes.SEARCH_PANEL_SET_FORMULA_NAME_INPUT,
    payload: {
        tabId: tabId,
        formulaName: formulaName
    }
});

export const setFormulaCodeInput = (tabId, formulaCode) => ({
    type: actionTypes.SEARCH_PANEL_SET_FORMULA_CODE_INPUT,
    payload: {
        tabId: tabId,
        formulaCode: formulaCode
    }
});

export const setBaseNameInput = (tabId, baseName) => ({
    type: actionTypes.SEARCH_PANEL_SET_BASE_NAME_INPUT,
    payload: {
        tabId: tabId,
        baseName: baseName
    }
});

export const setBippNameInput = (tabId, bippName) => ({
    type: actionTypes.SEARCH_PANEL_SET_BIPP_NAME_INPUT,
    payload: {
        tabId: tabId,
        bippName: bippName
    }
});

export const selectProduct = (tabId, product, bipp, autoselect, resetFilter) => ({
    type: actionTypes.SELECT_PRODUCT,
    payload: {
        tabId: tabId,
        product: product,
        bipp: bipp,
        autoselect: autoselect,
        resetFilter: resetFilter
    }
});

export const selectFandeck = (tabId, fandeck, autoselect, resetFilter) => ({
    type: actionTypes.SELECT_FANDECK,
    payload: {
        tabId: tabId,
        fandeck: fandeck,
        autoselect: autoselect,
        resetFilter: resetFilter
    }
});

export const selectFormula = (tabId, color, autoselect) => ({
    type: actionTypes.SELECT_FORMULA,
    payload: {
        tabId: tabId,
        color: color,
        autoselect: autoselect
    }
});

export const selectFormulaNameAndCode = (tabId, color, autoselect, resetFilter, formulaNameInput) => ({
    type: actionTypes.SELECT_FORMULA_NAME_AND_CODE,
    payload: {
        tabId: tabId,
        color: color,
        autoselect: autoselect,
        resetFilter: resetFilter,
        formulaNameInput: formulaNameInput
    }
});

export const selectBase = (tabId, base, bipp) => ({
    type: actionTypes.SELECT_BASE,
    payload: {
        tabId: tabId,
        base: base,
        bipp: bipp
    }
});

export const selectBipp = (tabId, bipp) => ({
    type: actionTypes.SELECT_BIPP,
    payload: {
        tabId: tabId,
        bipp: bipp
    }
});

export const removeSelected = (tabId, panel) => ({
    type: actionTypes.SEARCH_PANEL_REMOVE_SELECTED,
    payload: {
        tabId: tabId,
        panel: panel
    }
});

export const reloadFandeckList = (tabId, fandeckName, fandeckLimit, fandeckOffset) => ({
    type: actionTypes.RELOAD_FANDECK_LIST_SEARCH,
    payload: {
        tabId: tabId,
        fandeckName: fandeckName,
        fandeckLimit: fandeckLimit,
        fandeckOffset: fandeckOffset
    }
});

export const reloadFormulaListByName = (tabId, formulaName, formulaLimit, formulaOffset) => ({
    type: actionTypes.RELOAD_FORMULA_LIST_SEARCH_BY_NAME,
    payload: {
        tabId: tabId,
        formulaName: formulaName,
        formulaLimit: formulaLimit,
        formulaOffset: formulaOffset
    }
});

export const reloadFormulaListByCode = (tabId, formulaCode, formulaLimit, formulaOffset) => ({
    type: actionTypes.RELOAD_FORMULA_LIST_SEARCH_BY_CODE,
    payload: {
        tabId: tabId,
        formulaCode: formulaCode,
        formulaLimit: formulaLimit,
        formulaOffset: formulaOffset
    }
});

export const reloadFormulaListByNameAndCode = (tabId, formulaText, formulaLimit, formulaOffset) => ({
    type: actionTypes.RELOAD_FORMULA_LIST_SEARCH_BY_NAME_AND_CODE,
    payload: {
        tabId: tabId,
        formulaText: formulaText,
        formulaLimit: formulaLimit,
        formulaOffset: formulaOffset
    }
});

export const filterFormulaList = (tabId) => ({
    type: actionTypes.FILTER_FORMULA_LIST,
    payload: {
        tabId: tabId,
        autoselect: false
    }
});

export const filterFormulaListByName = (tabId, formulaName) => ({
    type: actionTypes.FILTER_FORMULA_LIST_BY_NAME,
    payload: {
        tabId: tabId,
        formulaName: formulaName
    }
});

export const filterFormulaListByCode = (tabId, formulaCode) => ({
    type: actionTypes.FILTER_FORMULA_LIST_BY_CODE,
    payload: {
        tabId: tabId,
        formulaCode: formulaCode
    }
});

export const filterFormulaListByNameAndCode = (tabId, formulaText) => ({
    type: actionTypes.FILTER_FORMULA_LIST_BY_NAME_AND_CODE,
    payload: {
        tabId: tabId,
        formulaText: formulaText
    }
});

export const reloadBaseList = (tabId, baseName, baseLimit, baseOffset) => ({
    type: actionTypes.RELOAD_BASE_LIST_SEARCH,
    payload: {
        tabId: tabId,
        baseName: baseName,
        baseLimit: baseLimit,
        baseOffset: baseOffset
    }
});

export const filterBaseListByName = (tabId, baseName, baseLimit, baseOffset) => ({
    type: actionTypes.FILTER_BASE_LIST_BY_NAME,
    payload: {
        tabId: tabId,
        baseName: baseName,
        baseLimit: baseLimit,
        baseOffset: baseOffset
    }
});

export const reloadBippList = (tabId, bippName, bippLimit, bippOffset) => ({
    type: actionTypes.RELOAD_BIPP_LIST_SEARCH,
    payload: {
        tabId: tabId,
        bippName: bippName,
        bippLimit: bippLimit,
        bippOffset: bippOffset
    }
});

export const filterBippListByName = (tabId, bippName, bippLimit, bippOffset) => ({
    type: actionTypes.FILTER_BIPP_LIST_BY_NAME,
    payload: {
        tabId: tabId,
        bippName: bippName,
        bippLimit: bippLimit,
        bippOffset: bippOffset
    }
});

export const selectClosestColorAndFandeck = (tabId, product, fandeck, color, delta) => ({
    type: actionTypes.SELECT_CLOSEST_COLOR_AND_FANDECK,
    payload: {
        tabId: tabId,
        product: product,
        fandeck: fandeck,
        color: color,
        delta: delta
    }
});

export const selectColorPaletteFormula = (tabId, color) => ({
    type: actionTypes.SELECT_COLOR_PALETTE_FORMULA,
    payload: {
        tabId: tabId,
        color: color
    }
});

export const focusOnNextPanel = (tabId, panel) => ({
    type: actionTypes.SEARCH_PANEL_FOCUS_ON_NEXT_PANEL,
    payload: {
        tabId: tabId,
        panel: panel
    }
});

export const toggleFormulaNameSort = (tabId) => ({
    type: actionTypes.SEARCH_PANEL_TOGGLE_FORMULA_NAME_SORT,
    payload: {
        tabId: tabId
    }
});

export const toggleFormulaCodeSort = (tabId) => ({
    type: actionTypes.SEARCH_PANEL_TOGGLE_FORMULA_CODE_SORT,
    payload: {
        tabId: tabId
    }
});

export const checkAutoselect = (tabId) => ({
    type: actionTypes.SEARCH_PANEL_CHECK_AUTOSELECT,
    payload: {
        tabId: tabId
    }
});

export const getClosestColorSearch = (tabId) => ({
    type: actionTypes.GET_CLOSEST_COLOR,
    payload: {
        tabId: tabId
    }
});

export const getClosestColorAndOpenLoading = (
    tabId,
    productId,
    fandeckId,
    compColorId,
    compFandeckId,
    compIsLocal,
    maxToleranceForCompetitiveColors,
    numberOfCompetitiveColors
) => [
    {
        type: actionTypes.SERVER_REQUEST,
        payload: {
            type: methods.METHOD_GET_CLOSEST_COLOR,
            params: {
                compColorId: compColorId,
                compFandeckId: compFandeckId,
                compIsLocal: compIsLocal,
                productId: productId,
                fandeckId: fandeckId,
                cieDe2000: maxToleranceForCompetitiveColors,
                rowCount: numberOfCompetitiveColors
            }
        },
        method: handlers.GET_CLOSEST_COLOR,
        tabId: tabId
    },
    {
        type: actionTypes.NAVIGATION_OPEN_MODAL,
        payload: {
            tabId: tabId,
            type: componentTypes.LOADING_MODAL,
            params: {
                message: translate("dialog.competitiveColorSearch"),
                onCancel: {
                    type: actionTypes.SKIP_WEBSOCKET_REQUEST,
                    payload: {
                        tabId: tabId,
                        method: handlers.GET_CLOSEST_COLOR
                    }
                }
            }
        }
    }
];
